import { User } from "../types";

export function getPrimaryName(user: User) {
  return user.personal_profile?.profile_names?.find(
    (name) => name.type === "PRIMARY"
  );
}
